export default __webpack_public_path__ + "static/media/paint-palette.66a08160.svg";